<div class="card">
  <div class="card-body">
    <h5 class="card-title card-title-style">{{ cardTitle }}</h5>
    <p class="card-text">{{ cardContent }}</p>
    @for (link of links; track link) {
      <a class="card-link" [routerLink]="link?.routerLink" [queryParams]="link?.queryParams">{{ link?.keyName | translation | async }}</a>
    }
  </div>
</div>
